$(function(){
	onResize();
	initCarousel();
	asyncImg();
	asyncBg(function(){
		// initParallax();
		// initVideo();
		initToShow();
		initMasonry();
	});
});